export default {
  '& .oc-code-sandbox': {
    position: 'absolute',
    aspectRatio: 16 / 9,
    width: '100%',
    height: '100%',
    margin: '1rem 0 3rem 0',

    '&__iframe': {
      position: 'absolute',
      left: 0,
      width: '100%',
      height: '-webkit-fill-available',
      border: 'none',
    },

    '&__icon': {
      marginLeft: 'auto',

      '&:hover': {
        cursor: 'pointer',
      },
    },

    '&__expanded': {
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      zIndex: '1349',
      height: '100%',
    },

    '&__button-container': {
      padding: '10px',
      display: 'flex',
      backgroundColor: '#f6f6f6',
      alignItems: 'center',
    },

    '&__button-label': {
      fontWeight: 700,
      fontSize: '1rem',
      color: '#271a38',
      textDecoration: 'none',
    },
  },
};
